import React from 'react';
import { Checkbox, FormControlLabel, FormGroup, Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import useFixedAssetsStatusForm from './hooks/useFixedAssetsStatusForm';
import FormPartial from '../../components/form/formContainer/FormPartial';
import TextInput from '../../components/form/formInputs/TextInput/TextInput';
import NumericInput from '../../components/form/formInputs/NumericInput/NumericInput';
import BaseForm, { ParamTypes } from '../../components/form/baseForm/BaseForm';
import { NumberMaxValues, RoutingValues } from '../../types/Shared.types';
import { ASSET_STATUS_FIELDS } from '../../constants/revisionHistory/revisionHistory.constants';

const FixedAssetsStatusForm = () => {
    const { id, type } = useParams<ParamTypes>();
    const {
        fields,
        handleFieldChange,
        handleInServiceChange,
        handleDisposalChange,
        formMethods,
        onCreate,
        onUpdate,
        onDelete,
        closeForm,
        isLoadingStatus,
        canCreateAssetStatus,
        canUpdateAssetStatus,
        canDeleteAssetStatus,
    } = useFixedAssetsStatusForm(id);

    return (
        <BaseForm
            title={'Fixed Asset Status'}
            formMethods={formMethods}
            isLoading={isLoadingStatus}
            isNew={type === RoutingValues.create}
            onCreate={onCreate}
            onUpdate={onUpdate}
            onDelete={onDelete}
            onCancel={closeForm}
            displayCreateButton={canCreateAssetStatus}
            displayUpdateButton={canUpdateAssetStatus}
            displayDeleteButton={canDeleteAssetStatus}
            showOnRevision={true}
            fieldMappings={ASSET_STATUS_FIELDS}
            entityUuid={fields?.uuid}>
            <FormPartial>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextInput
                            fullWidth
                            label="Status Code"
                            id="code"
                            value={fields.code}
                            onChange={handleFieldChange}
                            formMethods={formMethods}
                            required={true}
                            maxLength={30}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <NumericInput
                            fullWidth
                            label="Sort Order"
                            id="sortOrder"
                            value={fields.sortOrder}
                            onChange={handleFieldChange}
                            formMethods={formMethods}
                            required={true}
                            maxValue={NumberMaxValues.smallint}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <FormGroup
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}>
                            <FormControlLabel
                                label="In Service"
                                control={
                                    <Checkbox
                                        id="isInService"
                                        checked={fields.isInService}
                                        onChange={handleInServiceChange}
                                    />
                                }
                            />
                            <FormControlLabel
                                label="Disposal"
                                control={
                                    <Checkbox
                                        id="isDisposal"
                                        checked={fields.isDisposal}
                                        onChange={handleDisposalChange}
                                    />
                                }
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                        <TextInput
                            fullWidth
                            label="Description"
                            id="description"
                            value={fields.description}
                            onChange={handleFieldChange}
                            formMethods={formMethods}
                            maxLength={255}
                        />
                    </Grid>
                </Grid>
            </FormPartial>
        </BaseForm>
    );
};

export default FixedAssetsStatusForm;
